<div class="modal-header">
    <h4 class="modal-title">{{ step >= 0 ? wizardTitle : title }}</h4>
</div>
<form name="form" #form="ngForm">
    @if (step === 0) {
        <div class="modal-body">
            <div class="report-card-list d-flex flex-column gap-2 mb-3">
                @for (type of purchaseOrderTypes; track type) {
                    <button type="button" class="report-card {{ getCardClass(type) }}" (click)="selectType(type)">
                        <div class="report-card-icon">
                            <fa-icon [icon]="getCardIcon(type)" size="lg"></fa-icon>
                        </div>
                        <div class="report-card-content">
                            <div class="report-card-title">{{ getTypeDisplay(type) }}</div>
                            <div class="report-card-subtitle">{{ getCardSubtitle(type) }}</div>
                        </div>
                    </button>
                }
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
        </div>
    } @else if (step === 1) {
        <div class="modal-body">
            <div class="report-card-list d-flex flex-column gap-2 mb-4">
                <button type="button" class="report-card report-card-primary" (click)="selectWorkOrder(true)">
                    <div class="report-card-icon">
                        <fa-icon [icon]="faClipboardList" size="lg"></fa-icon>
                    </div>
                    <div class="report-card-content">
                        <div class="report-card-title">Work Order</div>
                        <div class="report-card-subtitle">Tied to an existing EM Work Order</div>
                    </div>
                </button>
                <button type="button" class="report-card report-card-warning" (click)="selectWorkOrder(false)">
                    <div class="report-card-icon">
                        <fa-icon [icon]="faWrench" size="lg"></fa-icon>
                    </div>
                    <div class="report-card-content">
                        <div class="report-card-title">Non-Work Order</div>
                        <div class="report-card-subtitle">Equipment purchase not tied to a Work Order</div>
                    </div>
                </button>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" style="margin-right: auto" (click)="goBack()">Back</button>
            <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
        </div>
    } @else if (step === 2) {
        <div class="modal-body">
            <h6 class="form-section-title">PO Header</h6>
            <div class="row">
                <div class="col-sm-6 col-12 form-group">
                    <label for="vendor">Vendor</label>
                    <wj-combo-box
                        [(ngModel)]="target.vendor"
                        name="vendor"
                        id="vendor"
                        [isRequired]="false"
                        [itemsSource]="vendorOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="row">
                <div class="col-12 form-group">
                    <label for="description">Description</label>
                    <input type="text" class="form-control" [(ngModel)]="target.description" name="description" id="description" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 col-6 form-group">
                    <label for="expectedDate">Expected Date</label>
                    <wj-input-date [(ngModel)]="poExpectedDate" name="expectedDate" id="expectedDate" [isRequired]="false"></wj-input-date>
                </div>
                <div class="col-sm-4 col-6 form-group">
                    <label for="orderDate">Order Date</label>
                    <wj-input-date [(ngModel)]="poOrderDate" name="orderDate" id="orderDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>

            @switch (target.type) {
                @case (PoType.JobMaterial) {
                    <app-job-material-form [item]="jobMaterialItem"></app-job-material-form>
                }
                @case (PoType.CreditCard) {
                    <app-credit-card-form [item]="creditCardItem"></app-credit-card-form>
                }
                @case (PoType.Equipment) {
                    @if (isWorkOrder) {
                        <app-equipment-wo-form [item]="equipmentWoItem"></app-equipment-wo-form>
                    } @else {
                        <app-equipment-form [item]="equipmentItem"></app-equipment-form>
                    }
                }
                @case (PoType.GeneralLedger) {
                    <app-expense-form [item]="expenseItem"></app-expense-form>
                }
            }
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" style="margin-right: auto" (click)="goBack()">Back</button>
            <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
                @if (isSaving) {
                    <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
                } @else {
                    <span>Save</span>
                }
            </button>
            <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
        </div>
    } @else {
        <div class="modal-body">
            <div class="row">
                <div class="col-12 form-group">
                    <label for="vendor">Vendor</label>
                    <wj-combo-box
                        [(ngModel)]="target.vendor"
                        name="vendor"
                        id="vendor"
                        [isRequired]="false"
                        [itemsSource]="vendorOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 form-group">
                    <label for="description">Description</label>
                    <input type="text" class="form-control" [(ngModel)]="target.description" name="description" id="description" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 form-group">
                    <label for="amount">Amount</label>
                    <input type="number" class="form-control" [(ngModel)]="target.amount" name="amount" id="amount" />
                </div>
            </div>
            @if (target.imageUrls && target.imageUrls.length > 0) {
                <div class="row">
                    <label for="images-display">Images/Files</label>
                    @for (url of target.imageUrls; track url) {
                        <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                            @if (isPdf(url)) {
                                <img class="attachment-pdf-thumb" style="cursor: pointer" [src]="getExistingImageSrc(url)" (click)="openImage(url)" alt="" />
                            } @else {
                                <img style="max-width: 250px; cursor: pointer" [src]="getExistingImageSrc(url)" (click)="openImage(url)" alt="" />
                            }
                        </div>
                    }
                </div>
            }
            @if (images && images.length > 0) {
                <div class="row">
                    <label for="images-upload">Images To Upload</label>
                    @for (image of images; track image) {
                        <div class="col-sm-6 col-6" style="max-width: 324px; margin-bottom: 10px">
                            <div class="close-x" (click)="removeImage(image)">
                                <fa-icon [icon]="faX"></fa-icon>
                            </div>
                            @if (image.type === 'application/pdf') {
                                <img class="attachment-pdf-thumb" [src]="getPendingImageSrc(image)" alt="" />
                            } @else {
                                <img style="max-width: 300px" [src]="getPendingImageSrc(image)" alt="" />
                            }
                        </div>
                    }
                </div>
            }
            @if (progress > 0 && progress < 100) {
                <div class="row">
                    <div class="col-12">
                        <div class="progress">
                            <div
                                class="progress-bar"
                                role="progressbar"
                                [ngStyle]="{ 'width.%': progress }"
                                [attr.aria-valuenow]="progress"
                                aria-valuemin="0"
                                aria-valuemax="100"
                            >
                                {{ progress }}%
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-success" style="margin-right: auto" (click)="fileInput.click()">Image/File</button>
            <input
                style="display: none"
                type="file"
                (change)="onFileChanged($event)"
                accept="image/*,application/pdf"
                #fileInput
                multiple
            />
            <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
                @if (isSaving) {
                    <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
                } @else {
                    <span>Save</span>
                }
            </button>
            <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
        </div>
    }
</form>
